import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vkuoemiy5k6">
      <div className="min-h-screen w-full bg-white font-sans text-navy selection:bg-volt selection:text-navy" data-id="element-1" data-mp="23ujl6el5pr4k">
        <noscript data-id="element-2" data-mp="3ijpbowku4r7n">
          <img height="1" width="1" style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3ii4su47vuwpm" />
        </noscript>

        <Hero data-id="element-4" data-mp="67yvnd9206b" />
        <main data-id="element-5" data-mp="4n4bxqxqh8g">
          <ProblemSection data-id="element-6" data-mp="5ggxfcks0yi" />
          <SolutionSection data-id="element-7" data-mp="7stfczkdj46" />
          <BonusesSection data-id="element-8" data-mp="2zllcouynw8jk" />
          <BenefitsSection data-id="element-9" data-mp="2zmenq84nlk7i" />
          <OfferSection data-id="element-10" data-mp="2zn6bwxvx8fnr" />
          <GuaranteeSection data-id="element-11" data-mp="33mf25srr5vek" />
          <Testimonials data-id="element-12" data-mp="33nq6put0v76q" />
          <FAQSection data-id="element-13" data-mp="33mym1f0yqtv8" />
          <FinalCTA data-id="element-14" data-mp="33oi1x4ipj2wh" />
        </main>
        <Footer data-id="element-15" data-mp="38li8rhnds9on" />
        <PurchasePopup data-id="element-16" data-mp="38l03xwmnkn54" />
      </div>
    </MotionConfig>;
}